// AdminDashboard.js
import React from 'react';
import AdminDashboard from '../AdminPage/components/AdminDashboard';



export default function AdminHome() {
  return (
    <div>
      <AdminDashboard/>
    </div>
  )
}
